import { BaseFieldProps } from "@/components/Form/RHF/FormFields/BaseField/BaseField.component";
import { CheckBoxField } from "@/components/Form/RHF/FormFields/CheckboxField/CheckBoxField.component";

import { BoxConditionsFormValues } from "../boxConditions.schema";

type BoxAgeConditionComponentProps<_ extends BoxConditionsFormValues> = Omit<
    BaseFieldProps<BoxConditionsFormValues, "boxConditions.ageCondition">,
    "name" | "required"
> & {
    required: boolean;
};

const BoxAgeConditionComponent = <T extends BoxConditionsFormValues>({
    required,
    label
}: BoxAgeConditionComponentProps<T>) => {
    return (
        <CheckBoxField<BoxConditionsFormValues>
            name={"boxConditions.ageCondition"}
            label={label}
            required={required}
        />
    );
};

export { BoxAgeConditionComponent };
